import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Grid2 } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FormFIltersInformeDicom } from '../interfaces/FormFiltersInformeDicom';
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import { useMemo } from "react";
import MButton from "../../../../components/inputs/yup/materialui/mButton";

interface FiltrosComponentProps {
    handleFilters: (formFilters: FormFIltersInformeDicom) => void;
};

//* Validacion del formulario
const validationSchema: yup.ObjectSchema<FormFIltersInformeDicom> = yup.object().shape({
    fecha: yup.date().required("La fecha de vencimiento es obligatoria"),
});

export const FiltrosComponent = ({ handleFilters }: FiltrosComponentProps) => {

    const today = useMemo(() => {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }, []);

    const {
        handleSubmit,
        control,
        watch,
        formState: { errors }
    } = useForm<FormFIltersInformeDicom>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            fecha: today
        },
    });

    const fechaVencimiento = watch("fecha");

    const onSubmit = async (data: FormFIltersInformeDicom) => handleFilters(data);

    return (
        <CustomAccordion title="Filtros" expandedDefault>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Grid2 container spacing={2} sx={{ 
                    marginTop: 1,
                    alignItems: "center",
                }}>

                    <Grid2 size={4}>
                        <InputFecha
                            fecha={fechaVencimiento}
                            label="Fecha de vencimiento"
                            name="fecha"
                            control={control}
                            error={errors.fecha}
                        />
                    </Grid2>

                </Grid2>

                {/* Contenedor del Botón */}
                <Grid2 size={{ xs: 8 }} sx={{ 
                    marginTop: '10px',
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                    <MButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={<FilterListIcon />}
                        sx={{ 
                            height: "40px", 
                            whiteSpace: "nowrap",
                            px: 3
                        }}
                    >
                        Filtrar
                    </MButton>
                </Grid2>
            </form>
        </CustomAccordion>
    );

}